/* eslint-disable */
// Define dependency imports
import util from 'bootstrap/js/src/util';
import collapse from 'bootstrap/js/src/collapse';
import dropdown from 'bootstrap/js/src/dropdown';
import tooltip from 'bootstrap/js/src/tooltip';
import popover from 'bootstrap/js/src/popover';
import modal from 'bootstrap/js/src/modal';
import tab from 'bootstrap/js/src/tab';
import highlight from 'jquery-highlight/jquery.highlight';

// Define local components
import content from './components/content';
import sitemap from './components/sitemap';
import search from './components/search';
import form from './components/form';
import img from './components/img';
import navigation from './components/navigation';
import { Accordion } from './components/accordion';
import contentTablewrap from './components/tables';
import { JumpLinks } from './components/jumplinks';
import SetupScrollToTop from './components/back-to-top';

content();
sitemap();
search();
form();
img();
navigation();
Accordion();
contentTablewrap();
JumpLinks();
SetupScrollToTop();
/* eslint-enable */
